angular.module('jv.Admin.Users.CommonListActions.Factory', [])
    .factory('commonUtilsFAC', [function () {
        return {
            findKeyInList: function(objArr, key, value){
                var exists = false;
                angular.forEach(objArr, function(obj){
                    if(obj[key]=== value){
                        exists = true;
                    }
                });
                return exists;
            }
        };
    }])
    .factory('commonListActionsFAC', ['commonUtilsFAC', function (commonUtilsFAC) {
        return {
            sortByRelevance: function(filters, sortConfig, sortKey) {
                if (filters && sortConfig) {
                    if ((filters.q || filters.searchString) && filters.sortBy === sortKey) {
                        if (!commonUtilsFAC.findKeyInList(sortConfig.sortOptions, 'id', sortKey)) {
                            sortConfig.sortOptions.unshift({
                                value: sortKey,
                                id: sortKey
                            });
                            if (sortConfig.selectedOption !== 0) {
                                sortConfig.selectedOption = 0;
                                sortConfig.selectedSortOrder = 0;
                            }
                        }
                    } else {
                        if (commonUtilsFAC.findKeyInList(sortConfig.sortOptions, 'id', sortKey)) {
                            sortConfig.sortOptions.splice(0,1);
                        }
                    }
                }
            }
        };
    }]);